module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/suns_footer_image_04-0cc77c4af6c66c974593cdeb86272125.jpg";